import { FC } from 'react';

import { PricePill } from 'components/common/PricePill';
import { Slideout, SlideoutCommonProps } from 'components/design-system/Slideout';
import { useModal } from 'context/modal/ModalContext';
import styles from 'styles/Auctions.module.scss';
import { Listing, ProxyBid } from 'types';

import { AllBidsModal } from './AllBidsModal';

export const BidSubmittedModalTestIds = {
  container: 'bid-submitted-modal-container'
};

export type BidSubmittedModalProps = {
  bidValue: number;
  closeModal: () => void;
  listing: Listing;
  proxyBid?: ProxyBid;
} & SlideoutCommonProps;

export const BidSubmittedModal: FC<BidSubmittedModalProps> = ({ isOpen, closeModal, bidValue, listing, proxyBid }) => {
  const { openModal, closeModal: closeBidModal } = useModal();

  const openAllBidModal = () =>
    openModal(<AllBidsModal proxyBid={proxyBid} listing={listing} closeModal={closeBidModal} />);

  return (
    <Slideout
      isDark
      data-testid={BidSubmittedModalTestIds.container}
      isOpen={isOpen}
      title={<PricePill isDark price={bidValue} />}
      closeModal={closeModal}
      className={styles.modal}
      bodyClassName='d-flex flex-column'
      submit={{
        title: 'View your bid',
        onClick: openAllBidModal,
        variant: 'turquoise'
      }}
    >
      <div className='riforma-regular text-center text-light flex-1 d-flex flex-column justify-content-around align-items-center'>
        <div>
          <div className='fs-18px fs-sm-20px my-4'>Bid submitted</div>
          <div className='opacity-60 mx-2 line-height-24px mb-5 mt-2 px-4'>
            Your bid has been made and it is currently the leading bid. We’ll notify you if someone has outbid you.
          </div>
        </div>
      </div>
    </Slideout>
  );
};
